import React, { useLayoutEffect, useRef } from "react";
import { createPortal } from "react-dom";
import FullPageLoader from "../../Components/FullPageLoader";
import { useTheme } from "@mui/material/styles";

// The native modal top layer makes the whole Manager inert, including its
// navigation and third-party portals, until the redirect succeeds or fails.
export default function BillingRedirectLoader({ message }) {
  const dialogRef = useRef(null);
  const theme = useTheme();
  useLayoutEffect(() => {
    const dialog = dialogRef.current;
    dialog.showModal();
    return () => dialog.close();
  }, []);

  return createPortal(
    <dialog
      ref={dialogRef}
      aria-label={message}
      aria-modal="true"
      onCancel={(event) => event.preventDefault()}
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        maxWidth: "none",
        maxHeight: "none",
        margin: 0,
        padding: 0,
        border: 0,
        background: theme.palette.background.default,
        color: "inherit",
      }}
    >
      <FullPageLoader message={message} />
    </dialog>,
    document.body
  );
}
